module.exports = __webpack_public_path__ + "img/solution4.aac76e1a.png";